// extracted by mini-css-extract-plugin
export default {"productDescription":"r--z","featuredDescription":"s--z","description":"t--z","more":"u--z","descriptionSku":"v--z"};